import { isAddonActive } from "@/lib/carBoost";

/** Kiemelés (list_boost) — AI címkék a kártya tetején. */

export function getListBoostAiLabels(car) {
  if (!isAddonActive(car, "list_boost")) return [];
  const raw = car?.list_boost_ai_labels;
  if (!Array.isArray(raw)) return [];
  const out = [];
  const seen = new Set();
  for (const item of raw) {
    const s = String(item || "").trim();
    if (!s || seen.has(s.toLowerCase())) continue;
    seen.add(s.toLowerCase());
    out.push(s);
    if (out.length >= 3) break;
  }
  return out;
}
